import type { Group } from '../../../access/types';
import { useUserGroupsQuery } from '../../../access/hooks/use-user-groups-query';
import { APPLICATION_CONFIGURATOR_GROUP_NAME } from '../constants';

export const selectIsAppConfigurator = (groups: Group[]): boolean =>
  groups.some((group) => group.name === APPLICATION_CONFIGURATOR_GROUP_NAME);

export const useIsAppConfiguratorQuery = () => {
  return useUserGroupsQuery<boolean>(selectIsAppConfigurator);
};
